// utils/csv.js
import { SENSOR_NAME_MAP, SENSOR_FIELDS } from '../constants/sensors'

/**
 * Export sensor data to CSV format
 * @param {Array} data - Array of sensor data objects
 * @param {Array} selectedFields - Array of field keys in format 'sensor:field'
 * @param {string} buoyId - Buoy identifier
 * @returns {void}
 */
export function exportToCSV(data, selectedFields, buoyId) {
  if (!data.length || !selectedFields.length) {
    alert('No data to export')
    return
  }

  const headers = ['Time', 'Buoy ID']
  selectedFields.forEach(fieldKey => {
    const [sensor, field] = fieldKey.split(':')
    const prettySensor = SENSOR_NAME_MAP?.[sensor] || sensor
    const prettyField = SENSOR_FIELDS?.[sensor]?.[field] || field
    headers.push(`${prettySensor} ${prettyField}`)
  })

  let csvContent = headers.join(',') + '\n'
  const grouped = {}
  
  data.forEach(d => {
    const fieldKey = `${d._measurement}:${d._field}`
    if (!selectedFields.includes(fieldKey)) return
    
    const timeKey = new Date(d._time).toISOString().slice(0, 16)
    if (!grouped[timeKey]) {
      grouped[timeKey] = { 
        time: timeKey, 
        buoy_id: d.buoy_id || d.buoyId 
      }
    }
    
    grouped[timeKey][fieldKey] = d._value
    
    // Handle mode for procv_co2:pCO2
    if (d.mode && fieldKey === 'procv_co2:pCO2') {
      grouped[timeKey][`${fieldKey}_mode`] = d.mode
    }
  })

  Object.values(grouped)
    .sort((a, b) => new Date(b.time) - new Date(a.time))
    .forEach(row => {
      const csvRow = [
        row.time.replace('T', ' ').slice(0, 16),
        row.buoy_id || 'Unknown'
      ]
      
      selectedFields.forEach(fieldKey => {
        const value = row[fieldKey]
        const mode = fieldKey === 'procv_co2:pCO2' ? row['procv_co2:pCO2_mode'] : undefined
        let displayValue = typeof value === 'number' ? value.toFixed(2) : value || ''
        
        if (mode) {
          displayValue += mode === 'a_m' ? ' (Air)' : mode === 'w_m' ? ' (Water)' : ''
        }
        
        csvRow.push(displayValue)
      })
      
      csvContent += csvRow.join(',') + '\n'
    })

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', `buoy_${buoyId}_data_${new Date().toISOString().slice(0, 10)}.csv`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



